import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {Action, Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {RegionService} from '../../../services/region.service';
import {ProService} from '../../../services/pro.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';

@Injectable()
export class MspAuthorityEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private regionService = inject(RegionService);
  private proService = inject(ProService);

  constructor() {}

  readMspAuthority$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspAuthorityActionTypes.GetMspAuthority),
    map((action: featureActions.GetMspAuthority) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        RegionIds: payload.RegionIds
      };
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMspAuthority
      };
      return this.regionService.ReadProAuthority(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg) {
            const finalUpdateRes = { ...updateRes, result: res.result };
            return [new featureActions.GetMspAuthoritySuccess(res.msg.body), new featureActions.UpdateInfoSuccessAction(finalUpdateRes)];
          } else {
            return [new featureActions.UpdateInfoFailAction(updateRes)];
          }
        })
      );
    })
  ));
  updateMspAuthority$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspAuthorityActionTypes.UpdateMspAuthority),
    map((action: featureActions.UpdateMspAuthority) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        Data: payload
      };
      return this.regionService.UpdateProAuthority(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.UpdateMspAuthority };
          if (result.result) {
            return [new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.UpdateMspAuthority
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  deleteMspAuthority$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.RegionMspAuthorityActionTypes.DeleteMspAuthority),
    map((action: featureActions.DeleteMspAuthority) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        Data: payload
      };
      return this.regionService.DeleteProAuthority(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteMspAuthority };
          if (result.result) {
            return [new featureActions.GetRegions(), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            console.log('error');
            return [new featureActions.UpdateInfoFailAction(result)];
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteMspAuthority
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

}
